var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.686 19.0648C36.686 29.0361 28.6027 37.1195 18.6313 37.1195C8.66002 37.1195 0.57666 29.0361 0.57666 19.0648C0.57666 9.09349 8.66002 1.01013 18.6313 1.01013C28.6027 1.01013 36.686 9.09349 36.686 19.0648Z",
    fill: "#DA48DA",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5525 28.8528C11.2985 28.7339 11.2794 28.3248 11.4902 27.6209C11.5717 27.3497 12.1471 25.649 12.7171 23.8251C13.1598 22.4087 13.8101 20.5383 13.7622 20.4955C13.7143 20.4527 12.2762 19.3967 10.6372 18.2123L7.36865 15.8007C6.84628 15.3203 6.87978 14.9636 7.46452 14.7733C7.57475 14.74 8.9263 14.7115 11.6724 14.6924L15.7126 14.6639L16.8532 11.1916C18.1328 7.28171 18.2287 7.01534 18.4396 6.8013C18.7127 6.52542 19.0626 6.62529 19.2783 7.03911C19.3981 7.27218 19.5802 7.80971 20.7161 11.263L21.828 14.6639L25.849 14.6925L30.0952 14.7781C30.3252 14.8447 30.5601 15.054 30.5601 15.1919C30.5601 15.3631 30.4067 15.5915 30.1335 15.8388C29.9658 15.9863 28.4753 17.085 26.817 18.2837L23.7737 20.4955C23.7642 20.5193 24.2482 22.0509 24.8521 23.9012C26.1413 27.8396 26.1988 28.0347 26.1988 28.3866C26.1988 28.8147 25.964 28.9859 25.5566 28.848C25.2595 28.7481 24.8089 28.4342 21.6458 26.1558L18.7703 24.1342C18.732 24.1342 17.4379 25.0427 15.8948 26.1558C11.9361 29.0098 11.9121 29.0288 11.5527 28.8528L11.5525 28.8528Z",
    fill: "#FADBF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6866 14.6772L13.7788 20.5126L18.7722 24.1185L23.7645 20.5126L21.8577 14.6772H15.6866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.29b11b3ef3f189923e9f74162994939a.svg";
export { ForwardRef as ReactComponent };